import React from 'react';
import styles from './CtaBand.module.css';

const TripleOval = () => (
    <svg width="132" height="44" viewBox="0 0 132 44" aria-hidden="true" className={styles.ovals}>
        <ellipse cx="34" cy="22" rx="30" ry="18" fill="none" stroke="#E5484D" strokeWidth="3"/>
        <ellipse cx="66" cy="22" rx="30" ry="18" fill="none" stroke="#F5A524" strokeWidth="3"/>
        <ellipse cx="98" cy="22" rx="30" ry="18" fill="none" stroke="#30A46C" strokeWidth="3"/>
    </svg>
);

// The dark "final call to action" band shown before the footer on Home and How to.
const CtaBand = ({heading, text, children}) => (
    <section className={styles.band}>
        <TripleOval/>
        <h2 className={styles.heading}>{heading}</h2>
        {text && <p className={styles.text}>{text}</p>}
        <div className={styles.buttons}>{children}</div>
    </section>
);

export default CtaBand;
